module.exports={
  "in %s": "i %s",
  "%s days": "%s dage",
  "Save to calendar": "Importer i din kalender"
}
